import { permissionType } from "../common/Functions";
import {
    SALARY_MANAGEMENT_TABS,
    FINANCE_OVERVIEW_TABS,
    getFinanceManagementTabPath,
} from "../finance/financeManagementTabs";
import { getLeaveManagementTabPath } from "../leave/leaveManagementTabs";

export const SidebarOption = [{
    key: "dashboard",
    text: "Dashboard",
    icon: "/svg/Icons/dashboard-icon.svg",
    navigate: "/dashboard",
    permission: "",
},
// {
//     key: "profile",
//     text: "Profile",
//     icon: "/svg/Icons/profile-icon.svg",
//     navigate: "/profile",
//     permission: "",
// },
{
    key: "employee_directory",
    text: "Employee Directory",
    icon: "/svg/Icons/employees-icon.svg",
    navigate: "/employee-directory",
    permission: "",
    nonAdminOnly: true,
},
{
    key: "user",
    text: "Employees",
    icon: "/svg/Icons/employees-icon.svg",
    navigate: "/employees",
    permission: permissionType.USER_MANAGEMENT,
},
{
    key: "projects_group",
    text: "Projects",
    icon: "/svg/Icons/project-icon.svg",
    isGroup: true,
    children: [
        {
            key: "projects",
            text: "Assigned Projects",
            navigate: "/assigned-projects",
            permission: permissionType.PROJECT_MANAGEMENT,
        },
        {
            key: "project_documentation",
            text: "Project Documentation",
            navigate: "/project-documentation",
            permission: permissionType.PROJECT_DOCUMENTATION,
        },
        {
            key: "offboarding_documents",
            text: "Offboarding Documents",
            navigate: "/offboarding-documents",
            permission: permissionType.OFFBOARDING_DOCUMENTS,
        },
        {
            key: "project_credentials",
            text: "Project Credentials",
            navigate: "/project-credentials",
            permission: permissionType.PROJECT_CREDENTIALS,
        },
    ],
},
{
    key: "project_management",
    text: "Project Management",
    icon: "/svg/Icons/project-management-icon.svg",
    navigate: "/project-management",
    permission: permissionType.PROJECT_MANAGEMENT,
},
{
    key: "client_management_group",
    text: "Client Management",
    icon: "/svg/Icons/client-management-icon.svg",
    isGroup: true,
    children: [
        {
            key: "company_details",
            text: "Company Details",
            navigate: "/company-details",
            permission: permissionType.COMPANY_DETAILS,
        },
        {
            key: "client_management",
            text: "Client Management",
            navigate: "/client-management",
            permission: permissionType.CLIENT_MANAGEMENT,
        },
        {
            key: "invoice_management",
            text: "Invoice Management",
            navigate: "/invoice-management",
            permission: permissionType.INVOICE_MANAGEMENT,
        },
    ],
},
{
    key: "company_group",
    text: "Company",
    icon: "/svg/Icons/company-details-icon.svg",
    isGroup: true,
    children: [
        {
            key: "company_ops",
            text: "Public Holidays",
            navigate: "/company-ops",
            permission: permissionType.COMPANY_OPS,
        },
        {
            key: "company_policy",
            text: "Company Policy",
            navigate: "/company-policy",
            permission: permissionType.COMPANY_POLICY,
        },
    ],
},
{
    key: "salary_group",
    text: "Salary",
    icon: "/svg/Icons/finance-management-icon.svg",
    isGroup: true,
    children: [
        ...SALARY_MANAGEMENT_TABS.map((tab) => ({
            key: `finance_${tab.key}`,
            text: tab.label,
            navigate: getFinanceManagementTabPath(tab.key),
            permission: tab.permission,
            anyPermissions: tab.anyPermissions,
        })),
        {
            key: "salary_slip",
            text: "Salary Slips",
            navigate: "/salary-slips",
            permission: permissionType.SALARY_SLIP,
        },
    ],
},
{
    key: "finance_management_group",
    text: "Finance Management",
    icon: "/svg/Icons/finance-overview-icon.svg",
    isGroup: true,
    children: FINANCE_OVERVIEW_TABS.map((tab) => ({
        key: `finance_${tab.key}`,
        text: tab.label,
        navigate: getFinanceManagementTabPath(tab.key),
        permission: tab.permission,
        anyPermissions: tab.anyPermissions,
        anyPermissionChecks: tab.anyPermissionChecks,
    })),
},
{
    key: "work_group",
    text: "Work & Time",
    icon: "/svg/Icons/hours-icon.svg",
    isGroup: true,
    children: [
        {
            key: "daily_hours",
            text: "Daily Work Updates",
            navigate: "/daily-hours",
            permission: permissionType.DAILY_HOURS,
        },
        {
            key: "task_filter",
            text: "Task Filter",
            navigate: "/task_filter",
            permission: permissionType.DAILY_HOURS,
        },
        {
            key: "attendance",
            text: "Attendance",
            navigate: "/attendance",
            permission: permissionType.ATTENDANCE,
        },
        // {
        //     key: "time_tracker",
        //     text: "Time Tracker",
        //     navigate: "/time-tracker",
        //     permission: permissionType.TIME_TRACKER,
        // },
        // {
        //     key: "time_tracker_admin",
        //     text: "Time Tracker Admin",
        //     navigate: "/time-tracker/admin",
        //     permission: permissionType.TIME_TRACKER,
        // },
        // {
        //     key: "performance_criteria",
        //     text: "Performance Criteria",
        //     navigate: "/performance-criteria",
        //     permission: permissionType.PERFORMANCE_CRITERIA,
        // },
    ],
},
{
    key: "leave_group",
    text: "Leave",
    icon: "/svg/Icons/leave-icon.svg",
    isGroup: true,
    children: [
        {
            key: "leave_request",
            text: "Leave Request",
            navigate: "/leave_request",
            permission: permissionType.LEAVE_REQUEST,
            adminHidden: true,
        },
        {
            key: "leave_approve",
            text: "Leave Management",
            navigate: getLeaveManagementTabPath("requests"),
            permission: permissionType.LEAVE_APPROVE,
        },
        {
            key: "leave_balances",
            text: "Leave Balances",
            navigate: getLeaveManagementTabPath("balances"),
            permission: permissionType.LEAVE_APPROVE,
            hrOrAdminOnly: true,
        },
    ],
},
{
    key: "role",
    text: "Role Management",
    icon: "/svg/Icons/role-management-icon.svg",
    navigate: "/roles",
    permission: permissionType.ROLE_MANAGEMENT,

},
{
    key: "sops",
    text: "SOPs",
    icon: "/svg/Icons/role-management-icon.svg",
    navigate: "/sops",
    permission: permissionType.SOP_MANAGEMENT,
},
// {
//     key: "my_salary_slips",
//     text: "My Salary Slips",
//     icon: "/svg/Icons/finance-management-icon.svg",
//     navigate: "/my-salary-slips",
//     permission: "",
//     ownSalarySlips: true,
// },
{
    key: "praise_message",
    text: "Team praise",
    icon: "/svg/Icons/praise-icon.svg",
    navigate: "/team-praise",
    permission: permissionType.PRAISE_MESSAGES,
},
{
    key: "logout",
    text: "Logout",
    icon: "/svg/Icons/logout-icon.svg",
    navigate: "logout", // Special case, will be handled differently
    permission: "",
}]